export default "__VITE_ASSET__CcXq_jmq__"